import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {http_auth} from "@utils"
import {toast} from "react-toastify"
import * as auth from "../Auth"
import {EMPTY_DATA, REFRESH_TOKEN} from "../../../utility/Utils"

export const createApplicantPerson = createAsyncThunk('operator/createApplicantPerson', async (data, {
    rejectWithValue,
    dispatch
}) => {
    try {
        const response = await http_auth.post('/registration/v1/person/save', data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data?.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
        return rejectWithValue(error.message)
    }
})

export const createApplicantLegal = createAsyncThunk('operator/createApplicantLegal', async (data, {
    rejectWithValue,
    dispatch
}) => {
    try {
        const response = await http_auth.post('/registration/v1/legal-entity/save', data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data?.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
        return rejectWithValue(error.message)
    }
})

export const getAttributeList = createAsyncThunk('operator/getAttributeList', async (data, {
    rejectWithValue,
    dispatch
}) => {
    try {
        const response = await http_auth.post('/admin/v1/attribute/list', data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data?.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
        return rejectWithValue(error.message)
    }
})

export const createAttribute = createAsyncThunk('operator/createAttribute', async (data, {
    rejectWithValue,
    dispatch
}) => {
    try {
        const response = await http_auth.get('/admin/v1/attribute/save', data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data?.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
        return rejectWithValue(error.message)
    }
})

export const getAttributeValueList = createAsyncThunk('operator/createAttribute', async (data, {
    rejectWithValue,
    dispatch
}) => {
    try {
        const response = await http_auth.post('/admin/v1/attribute-value/list', data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data?.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
        return rejectWithValue(error.message)
    }
})

export const getMaterialSubTypeList = createAsyncThunk('operator/getMaterialSubTypeList', async (data, {
    rejectWithValue,
    dispatch
}) => {
    try {
        const response = await http_auth.post('/registration/v1/thing-sub-type/list', data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data?.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
        return rejectWithValue(error.message)
    }
})

export const getRegionsList = createAsyncThunk('sys/getRegionsList', async ({rejectWithValue, dispatch}) => {
    try {
        const response = await http_auth.get('/registration/v1/soato/regions')
        return response.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
        return rejectWithValue(error.message)
    }
})

export const getSubRegionsList = createAsyncThunk('filter/getSubRegionsList', async (region_id) => {
    const response = await http_auth.get(`/registration/v1/soato/districts/${region_id}`)
    return response.data
})

export const createNewThing = createAsyncThunk('operator/createNewThing', async (data, {rejectWithValue}) => {
    try {
        const response = await http_auth.post('/registration/v1/thing/save', data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data?.data
    } catch (error) {
        return rejectWithValue(error.message)
    }
})

export const getThingList = createAsyncThunk('operator/getThingList', async (data, {rejectWithValue, dispatch}) => {
    try {
        const response = await http_auth.post('/registration/v1/thing/list', data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
        return rejectWithValue(error.message)
    }
})

export const getThingListDoc = createAsyncThunk('operator/getThingListDoc', async (data, {
    rejectWithValue,
    dispatch
}) => {
    try {
        const response = await http_auth.post('/registration/v1/thing/list', data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
        return rejectWithValue(error.message)
    }
})
export const getThingListThing = createAsyncThunk('operator/getThingListThing', async (data, {
    rejectWithValue,
    dispatch
}) => {
    try {
        const response = await http_auth.post('/registration/v1/thing/list', data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
        return rejectWithValue(error.message)
    }
})

export const materialAttributeSave = createAsyncThunk('operator/materialAttributeSave', async (data, {rejectWithValue}) => {
    try {
        const response = await http_auth.post('/registration/v1/thing-attribute/save', data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data?.data
    } catch (error) {
        return rejectWithValue(error.message)
    }
})

export const getDeclineRequestsList = createAsyncThunk('operator/getDeclineRequestsList', async (data, {
    rejectWithValue,
    dispatch
}) => {
    try {
        const response = await http_auth.post('/registration/v1/thing/request-declines', data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
        return rejectWithValue(error.message)
    }
})

export const getCompareInItemIntegration = createAsyncThunk('operator/getCompareInItemIntegration', async (data, {
    rejectWithValue,
    dispatch
}) => {
    try {
        const response = await http_auth.post('/integration/v1/buyum/thing-buyum-compare', data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
        return rejectWithValue(error.message)
    }
})

export const sendSmsInformLoser = createAsyncThunk('operator/sendSmsInformLoser', async (data, {
    rejectWithValue,
    dispatch
}) => {
    try {
        const response = await http_auth.post('/registration/v1/found/send-sms-lost-found-inform-loser', data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
        return rejectWithValue(error.message)
    }
})

export const checkDocumentIntegration = createAsyncThunk('operator/checkDocumentIntegration', async (data, {
    rejectWithValue,
    dispatch
}) => {
    try {
        const response = await http_auth.post('/integration/v1/buyum/check-document', data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
        return rejectWithValue(error.message)
    }
})

export const thingSlice = createSlice({
    name: 'thing',
    initialState: {
        personUsersList: [],
        legalUsersList: [],
        legalUserById: [],
        personUserById: [],
        decRequests: [],
        compareItem: null,
        checkDoc: null,

        thingList: [],
        docThingList: [],
        thing_list: [],
        attribute: [],
        attributeValue: {},
        materialSubType: [],
        regions: [],
        subRegion: [],

        currentPage: 0,
        totalItem: 0,
        totalPages: 0,
        isLoading: false,

        current_page: 0,
        count_item: 0,
        total_count: 0,

        current_page_thing: 0,
        count_item_thing: 0,
        total_count_thing: 0
    },
    reducers: {},
    extraReducers: {
        // Found thing list
        [getThingList.fulfilled]: (state, actions) => {
            const data = actions.payload?.data
            if (data?.length === 0) {
                toast.error(EMPTY_DATA)
            }
            state.thingList = data
            state.current_page = actions.payload?.page
            state.count_item = actions.payload?.count
            state.total_count = actions.payload?.total_count
            state.isLoading = false
        },
        [getThingListThing.fulfilled]: (state, actions) => {
            state.thing_list = actions?.payload?.data
            state.current_page_thing = actions.payload?.page
            state.count_item_thing = actions.payload?.count
            state.total_count_thing = actions.payload?.total_count
        },

        [getThingList.pending]: (state) => {
            state.isLoading = true
        },
        [getThingList.rejected]: (state, action) => {
            toast.error(action.payload)
            state.isLoading = false
        },

        // Attribute list
        [getAttributeList.fulfilled]: (state, actions) => {
            state.attribute = actions.payload
            state.isLoading = false
        },
        [getAttributeList.pending]: (state) => {
            state.isLoading = true
        },
        [getAttributeList.rejected]: (state, action) => {
            toast.error(action.payload)
            state.isLoading = false
        },

        // Attribute value list
        [getAttributeValueList.fulfilled]: (state, actions) => {
            state.attributeValue[actions.meta?.arg?.attribute_id] = actions.payload
            state.isLoading = false
        },
        [getAttributeValueList.pending]: (state) => {
            state.isLoading = true
        },
        [getAttributeValueList.rejected]: (state, action) => {
            toast.error(action.payload)
            state.isLoading = false
        },

        // decline requests
        [getDeclineRequestsList.fulfilled]: (state, actions) => {
            state.decRequests = actions.payload?.data
            state.current_page = actions.payload?.page
            state.count_item = actions.payload?.count
            state.total_count = actions.payload?.total_count
            state.isLoading = false
        },
        [getDeclineRequestsList.pending]: (state) => {
            state.isLoading = true
        },
        [getDeclineRequestsList.rejected]: (state, action) => {
            toast.error(action.payload)
            state.isLoading = false
        },

        // Material sub-type list
        [getMaterialSubTypeList.fulfilled]: (state, actions) => {
            state.materialSubType = actions.payload
            state.isLoading = false
        },
        [getMaterialSubTypeList.pending]: (state) => {
            state.isLoading = true
        },
        [getMaterialSubTypeList.rejected]: (state, action) => {
            toast.error(action.payload)
            // state.isLoading = false
        },

        // SOATO APIES
        [getRegionsList.fulfilled]: (state, actions) => {
            state.regions = actions.payload
            // state.isLoading = false
        },

        [getSubRegionsList.fulfilled]: (state, actions) => {
            state.subRegion = actions.payload
            // state.isLoading = false
        },

        // BUYUM AT

        [getCompareInItemIntegration.fulfilled]: (state, actions) => {
            state.compareItem = actions?.payload
            state.isLoading = false
        },
        [getCompareInItemIntegration.pending]: (state) => {
            state.isLoading = true
        },
        [getCompareInItemIntegration.rejected]: (state, action) => {
            toast.error(action.payload)
            state.isLoading = false
        },

        [checkDocumentIntegration.fulfilled]: (state, actions) => {
            state.checkDoc = actions?.payload
            state.isLoading = false
        },
        [checkDocumentIntegration.pending]: (state) => {
            state.isLoading = true
        },
        [checkDocumentIntegration.rejected]: (state, action) => {
            toast.error(action.payload)
            state.isLoading = false
        }
    }
})

export const {} = thingSlice.actions
export default thingSlice.reducer
